<template>
  <div>
    Admin View
  </div>
</template>

<script>
export default {
  name: 'ViewAdmin'
}
</script>
